import React, { ReactNode } from "react";
import { ExternalLink } from "./ExternalLink";
import { FooterExternalLink } from "./FooterLink";

interface Translation {
  landingPageDocumentTitle: string;
  appTitle: string;
  appDescription: ReactNode;
  appShortDescription: string;
  gainHealthHeader: string;
  gainHealthSubtitle: string;
  ptmszEndorsement: string;
  useFreeApp: string;
  ratingInAppStore: string;
  benefitMoreHealth: string;
  benefitAreas: string;
  benefitHealthSequences: string;
  benefitMoreAchieveGoal: string;
  ourTeam: string;
  downloadForFree: string;
  joinCommunity: string;
  contactUs: string;
  companyAddress: string;
  copyrightNotice: string;
  allRightsReserved: string;
  lifePlusProject: ReactNode;
  privacyPolicy: ReactNode;
  joinUs: string;
  articlesAboutUs: string;
  benefitsTitle: string;
  howToJoinLeague: string;
  installVika: string;
  tapButtonBelow: string;
  alreadyHaveVika: string;
  joinLeague: string;
  cookiesConsent: ReactNode;
  cookiesAccept: string;
  navHome: string;
  navTeam: string;
  navInsurers: string;
  navBiologicalAgeTitle: string;
  navBiologicalAgeSubtitle: string;
  navCareers: string;
  navFacebook: string;
  learnMore: string;
  readMore: string;
  deleteAccount: string;
  accountCreationDate: string;
  userForProviderNotFound: string;
  deletingAccount: string;
  accountWasDeleted: string;
  errorWhenDeletingAccount: string;
  signingIn: string;
  deleteAccountConfirmation: string;
  signInWithFacebook: string;
  signInWithApple: string;
  goBack: string;
  useSignUpProvider: string;
}

export const translations: { [key: string]: Translation } = {
  pl: {
    landingPageDocumentTitle: "Vika - zyskaj zdrowie",
    appTitle: "Asystent zdrowego stylu życia",
    appDescription: (
      <span>
        Czy wiesz ile lat zdrowia przed Tobą?
        <br />
        Sprawdź i zadbaj o zdrowie od dziś!
      </span>
    ),
    appShortDescription:
      "Sprawdź, ile lat zdrowia przed Tobą i dowiedz się, ile możesz ich zyskać. Zdobywaj punkty, zdrowe nawyki i… ciesz się życiem!",
    gainHealthHeader: "Zyskaj\nzdrowie",
    gainHealthSubtitle: "Postępy już\npierwszego dnia",
    ptmszEndorsement: "„Wyniki poprawy stylu życia są imponujące”",
    useFreeApp: "Pobierz Vikę bezpłatnie:",
    ratingInAppStore: "ocena w App Store",
    benefitMoreHealth: "Nawet 15 lat zdrowia więcej",
    benefitAreas: "Dieta, Sen i Ćwiczenia opracowane dla Ciebie",
    benefitHealthSequences: "Zdobądź komplet 11 ścieżek zdrowia",
    benefitMoreAchieveGoal: "Ciesz się zdrowiem, osiągaj Twój cel",
    ourTeam: "Nasz zespół",
    downloadForFree: "Pobierz Vikę\nbezpłatnie",
    joinCommunity: "Dołącz do\nspołeczności Viki",
    contactUs: "Napisz do nas",
    companyAddress:
      "Lab4Life Sp. z o.o.\nPomorski Park Naukowo-Technologiczny\nal. Zwycięstwa 96/98, Gdynia",
    copyrightNotice: "©2025 Lab4Life Sp. z o.o.",
    allRightsReserved: "Wszelkie prawa zastrzeżone",
    lifePlusProject: (
      <span>
        Vika wykorzystuje rezultaty prac B+R współfinansowanych przez Narodowe
        Centrum Badań i Rozwoju w ramach projektu „
        <a href="http://lab4.life">Life+</a>”.
      </span>
    ),
    privacyPolicy: (
      <FooterExternalLink href="/www-privacy-policy-pl.html">
        Zasady ochrony prywatności
      </FooterExternalLink>
    ),
    joinUs: "Dołącz do użytkowników Viki",
    articlesAboutUs: "O aplikacji Vika piszą",
    navHome: "Vika",
    navTeam: "Zespół",
    navInsurers: "Dla ubezpieczycieli",
    navBiologicalAgeTitle: "Kalkulator",
    navBiologicalAgeSubtitle: "Wieku biologicznego",
    navCareers: "Praca",
    navFacebook: "Vika na",
    learnMore: "Dowiedz się więcej",
    readMore: "czytaj więcej",
    benefitsTitle: "Co dostajesz z Viką?",
    howToJoinLeague: "Jak dołączyć do ligi?",
    installVika: "Zainstaluj Vikę.",
    tapButtonBelow: "Stuknij w przycisk poniżej.",
    alreadyHaveVika: "MAM JUŻ VIKĘ",
    joinLeague: "DOŁĄCZ DO LIGI",
    cookiesConsent: (
      <span>
        Używamy cookies i podobnych technologii w celu dostosowania naszych
        usług do potrzeb Użytkowników. Więcej informacji uzyskasz w{" "}
        <ExternalLink href="/www-privacy-policy-pl.html">
          Zasadach ochrony prywatności.
        </ExternalLink>
      </span>
    ),
    cookiesAccept: "AKCEPTUJĘ",
    deleteAccount: "Usuń konto",
    accountCreationDate: "Data utworzenia konta",
    userForProviderNotFound:
      "Nie znaleźliśmy takiego konta. Pamiętaj, żeby użyć tej samej metody logowania, co w aplikacji.",
    deletingAccount: "Usuwanie konta...",
    accountWasDeleted: "Konto zostało usunięte",
    errorWhenDeletingAccount: "Podczas usuwania konta wystąpił błąd",
    signingIn: "Trwa logowanie...",
    deleteAccountConfirmation: "Rozumiem, że tego działania nie można cofnąć",
    signInWithFacebook: "Zaloguj się przez Facebooka",
    signInWithApple: "Zaloguj się przez Apple",
    goBack: "Wróć",
    useSignUpProvider: "Wybierze metodę logowania użytą do zakładania konta",
  },
};

const defaultTranslation: Translation = {
  landingPageDocumentTitle: "Vika - earn health",
  appTitle: "Healthy lifestyle assistant",
  appDescription: (
    <span>
      Do you know how many years of health are ahead of you?
      <br />
      Check and take care of your health today!
    </span>
  ),
  appShortDescription:
    "Check how many years of health life ahead of you and find out how much you can gain. Join the mission developed by scientists, trainers and dietitians.",
  gainHealthHeader: "Gain\nhealth",
  gainHealthSubtitle: "Progress since\nday one",
  ptmszEndorsement:
    "“The results of the lifestyle improvements are impressive”",
  ratingInAppStore: "App Store rating",
  benefitMoreHealth: "Up to 15 healthy years more",
  benefitAreas: "Diet, Sleep and Workouts developed for You",
  benefitHealthSequences: "Complete 11 health paths",
  benefitMoreAchieveGoal: "Enjoy your health, achieve your goal",
  useFreeApp: "Download for free:",
  ourTeam: "Our team",
  downloadForFree: "Download Vika\nfor free",
  joinCommunity: "Join online\ncommunity",
  contactUs: "Mail us",
  companyAddress:
    "Lab4Life Sp. z o.o.\nPomorski Park Naukowo-Technologiczny\nal. Zwycięstwa 96/98, Gdynia",
  copyrightNotice: "©2023 Lab4Life Sp. z o.o.",
  allRightsReserved: "All rights reserved",
  lifePlusProject: (
    <span>
      The mobile application Vika is partially funded by the European Fund. The
      Vika app is a tool that draws on the results from the research project
      under the name ‘<a href="http://lab4.life">Life+</a>’ which has been
      financially supported by the National Centre for Research and Development
      (NCBR).
    </span>
  ),
  privacyPolicy: (
    <FooterExternalLink href="/www-privacy-policy-en.html">
      Privacy policy
    </FooterExternalLink>
  ),
  joinUs: "Join the users of Vika",
  articlesAboutUs: "Vika in the news",
  navHome: "Vika",
  navTeam: "Team",
  navInsurers: "For insurers",
  navBiologicalAgeTitle: "Biological age",
  navBiologicalAgeSubtitle: "Calculator",
  navCareers: "Jobs",
  navFacebook: "Vika on",
  learnMore: "Learn more",
  readMore: "read more",
  benefitsTitle: "What do you gain with Vika?",
  howToJoinLeague: "How can I join a league?",
  installVika: "Install Vika.",
  tapButtonBelow: "Tap button below.",
  alreadyHaveVika: "I ALREADY HAVE VIKA",
  joinLeague: "JOIN LEAGUE",
  cookiesConsent: (
    <span>
      We use cookies and similar technologies to adapt our services to the needs
      of the Users. For more information, please refer to the{" "}
      <ExternalLink href="/www-privacy-policy-en.html">
        Privacy Policy
      </ExternalLink>{" "}
      .
    </span>
  ),
  cookiesAccept: "ACCEPT",
  deleteAccount: "Delete account",
  accountCreationDate: "Account creation date",
  userForProviderNotFound:
    "We couldn't find such user account. Remember to use the same sign-in method as in the app.",
  deletingAccount: "Deleting the account...",
  accountWasDeleted: "The account was deleted",
  errorWhenDeletingAccount: "An error occurred while deleting the account",
  signingIn: "Signing in...",
  deleteAccountConfirmation: "I understand that this action cannot be undone",
  signInWithFacebook: "Sign in with Facebook",
  signInWithApple: "Sign in with Apple",
  goBack: "Go back",
  useSignUpProvider: "Select the sign-in method you used during registration",
};

export const locale = navigator.language;

export const language = navigator.language.split(/[-_]/)[0]; // language without region code

export const translation: Translation =
  translations[language] ?? defaultTranslation;
